import styled from 'styled-components';

const UpdateEmailContainer = styled.div`
  ${({ theme }) => theme.pages.updateEmail.updateEmailContainer};
`;

export { UpdateEmailContainer };
